import { render } from "./Beritaisi.vue?vue&type=template&id=495e2755"
import script from "./Beritaisi.vue?vue&type=script&lang=js"
export * from "./Beritaisi.vue?vue&type=script&lang=js"

import "./Beritaisi.vue?vue&type=style&index=0&id=495e2755&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__